import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
function RegisterBox({closeRegisterBox}) {
  return (
    <Container>
        


        <div className="container">

        <div className="form-container col-sm-12 col-xl-6 col-md-10">

        <form action="">
        <span id='close-btn'><p>
            <CloseIcon onClick={() => closeRegisterBox(false) }/></p></span>
            <p>Registration</p>
            <hr />
            <label htmlFor="fname">Full Name</label>
            <input type="text" placeholder='Full Name' required/>

            <label htmlFor="phone">Phone No.</label>
            <input type="phone" placeholder='Phone' required/>

            <label htmlFor="">Email</label>
            <input type="email" placeholder='Email' required/>

            <hr />

            <div className="btn-group">

            <button onClick={()=>{
            closeRegisterBox(false)
        }} id='close-btn-bottom'>Close</button>

        <button type='submit'>Submit</button>
            </div>


        </form>
        </div>
        </div>

    </Container>
  )
}

export default RegisterBox
const Container = styled.div` 
position: fixed;
left:0 ;
top:70px;
background-color:rgb(0,0,0,.4) ;
width:100% ;
height:100vh ;
margin:auto ;

    input{
        width:100%;
        height:40px ;
        border:1px solid #878787 ;
        border-radius:5px ;
        padding:10px ; 
        &:hover{
            border:1px solid #fa7525 ;
        }
    }
            .form-container{
                background:white ;
                box-sizing:border-box ;
                padding:20px ;
                margin:auto ;
                margin-top:50px ;
                border-radius:10px ;
            }
            .form-container label{
                color:black ;
            }
            button{
                background-color:#fa7525 ;
                margin-right:0 ;
                border:none ;
                padding:10px ;
                margin:5px ;
                border-radius:10px ;

                &:hover{
                    background-color:black ;
                    color:#fa7525 ;
                }
                
            }
            #close-btn-bottom{
                background-color:white ;
                border:1px solid #fa7525 ;
            }
            P{
                font-size:30px ;
                color:#fa7525 ;
            }
            .btn-group{
                display: flex;
                justify-content:end ;
                
            }
            #close-btn{
                text-align:right;
                cursor: pointer;
            }


`